import React from 'react';
import styled from 'styled-components';

// style-------------------------------------------------------------------
const Ahover = styled.a`
    :hover {
        text-decoration: underline !important;
        color: blue !important;
        transition: color .15s;
    }
`


// component-------------------------------------------------------------------
export const StyleA = props => {
    const { children, ...other } = props;
    return <Ahover {...other}>{children}</Ahover>
}


// styled ---------------------------------------------
export const StyleRoot = styled.div`
  /* position: absolute;
  top: 10%;
  left: 50%;
  transform: translateX(-50%); */
  font-size: 1.2em;
  min-width: 350px;
  width: 60%;
  padding: 0 20px;
  .MuiStepper-root {
    background-color: rgb(247, 247, 247);
  }
`;